<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <mat-icon *ngIf="level == 2">warning</mat-icon>
  <mat-icon *ngIf="level == 3">error</mat-icon>
  <span [innerHtml]="message" class="message"></span>
</mat-dialog-content>
<div *ngIf="displayButton" mat-dialog-actions>
  <button mat-button class="button--primary" (click)="close()">Ok</button>
</div>
